/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceQueryTagKeyValuesKind extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceQueryTagKeyValuesKind");
    }

    getFixupPrototypeFunction() { return ResourceQueryTagKeyValuesKind.fixupPrototype; }

    static newInstance(model: Partial<ResourceQueryTagKeyValuesKind>): ResourceQueryTagKeyValuesKind {
        let obj = Object.assign(new ResourceQueryTagKeyValuesKind(), model);
        ResourceQueryTagKeyValuesKind.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceQueryTagKeyValuesKind>): ResourceQueryTagKeyValuesKind {
        if (!model) return null;
        return ResourceQueryTagKeyValuesKind.newInstance(<ResourceQueryTagKeyValuesKind> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceQueryTagKeyValuesKind) {
        if (!obj) return;

        models.ResourceQueryTagKeyValuesKind.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceQueryTagKeyValuesKind): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceQueryTagKeyValuesKind.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tag key for the given resources
     */
    tag_key: string;

    /**
     * Tag kind for the given key; empty or omitted means kind-less (e.g. AI platform tags)
     */
    tag_kind: string;

    /**
     * Tag values for the given key
     */
    tag_values: Array<string>;

}
